// Shared helpers for reading a Task's schedule. Used by the Task Library cards
// and by the "Automate" pill under a chat message, so both render a cadence the
// same way.

export const isScheduled = (task) =>
  Boolean(task?.repeat) && String(task.repeat).toLowerCase() !== "none";

// "daily" -> "Daily". The backend stores a bare cadence word.
export const formatCadence = (value) =>
  String(value || "")
    .replace(/[-_]+/g, " ")
    .replace(/^\w/, (c) => c.toUpperCase());

// scheduleTime is stored as "YYYY-MM-DD HH:mm"; the pill only shows the clock,
// with the leading zero dropped ("2026-09-21 08:00" -> "8:00").
export const formatScheduleClock = (scheduleTime) => {
  const match = String(scheduleTime || "").match(/(\d{1,2}):(\d{2})/);
  if (!match) return "";
  return `${Number(match[1])}:${match[2]}`;
};

const normalise = (value) =>
  String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

/**
 * When the message the user sent is one of their already-scheduled Tasks, the
 * chat pill shows the cadence + destination instead of offering "Automate".
 * A Task is run by prefilling the composer with its `prompt_value`, so the
 * message matches on that, falling back to a leading title match for messages
 * the user edited before sending.
 */
export const findAutomatedTask = (content, tasks) => {
  const text = normalise(content);
  if (!text || !Array.isArray(tasks)) return undefined;

  const match = tasks.find((task) => {
    if (!isScheduled(task)) return false;
    const prompt = normalise(task.prompt_value);
    const title = normalise(task.title);
    return (prompt && text === prompt) || (title && text.startsWith(title));
  });

  if (!match) return undefined;

  return {
    id: match._id || match.id,
    frequency: formatCadence(match.repeat),
    clock: formatScheduleClock(match.scheduleTime),
    // `output` carries the destination provider ("slack" / "microsoft-teams" /
    // "chatUi"); `channel_name` is the human-readable target within it.
    provider: match.output,
    channelName: match.channel_name,
  };
};
